import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class IaService {
	constructor(private http: HttpClient) { }

	
	
	hasService(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.ia:hasService',
			params: {
				
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.ia:list',
			params: {
				options:options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	requete(texte:string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.ia:requete',
			params: {
				texte: texte
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	remove(id:any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.ia:remove',
				params: {
					id: id
				},
			})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
